import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export type HttpErrorOutcome =
  'silent' | 'recover' | 'toast-4xx' | 'toast-network' | 'toast-5xx';

export const classifyHttpError = (
  error: HttpErrorResponse,
  hasValidAccessToken: boolean
): HttpErrorOutcome => {
  if (error.status === HttpStatusCode.Unauthorized) {
    return hasValidAccessToken ? 'silent' : 'recover';
  }
  if (error.status === HttpStatusCode.NotFound) {
    return 'silent';
  }
  if (error.status === 0) {
    return 'toast-network';
  }
  if (error.status >= HttpStatusCode.InternalServerError) {
    return 'toast-5xx';
  }
  if (error.status >= HttpStatusCode.BadRequest) {
    return 'toast-4xx';
  }
  return 'silent';
};
